/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsThumbUp: {
  name: 'thumb-up';
  data: string;
} = {
  name: 'thumb-up',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.5 3.414c0-1.336-1.616-2.006-2.56-1.06l-3 3a1.5 1.5 0 0 0-.44 1.06V14A1.5 1.5 0 0 0 5 15.5h7.323a1.5 1.5 0 0 0 1.393-.943l1.677-4.193a1.5 1.5 0 0 0 .107-.557V8A1.5 1.5 0 0 0 14 6.5h-4a.5.5 0 0 1-.5-.5V3.414Zm-1.854-.353a.5.5 0 0 1 .854.353V6A1.5 1.5 0 0 0 10 7.5h4a.5.5 0 0 1 .5.5v1.807a.499.499 0 0 1-.036.186l-1.677 4.193a.5.5 0 0 1-.464.314H5a.5.5 0 0 1-.5-.5V6.414a.5.5 0 0 1 .146-.353l3-3ZM1.5 6a.5.5 0 1 0-1 0v9a.5.5 0 0 0 1 0V6Z" fill="currentColor"/></svg>`,
};
